import { IKeyValuePair } from "@interfaces/IKeyValuePair";

export class EnumService {

    static enumCache: IKeyValuePair<any>[][] = [];

    static getItemsForSelect<T>(enumType: any): IKeyValuePair<T>[] {
        const items = this.getNames(enumType).map(name => {
            const selectListItem: IKeyValuePair<T> = {
                name: name,
                value: enumType[name]
            }

            return selectListItem;
        });

        items.sort((x, y) => { return x.name.localeCompare(y.name); });

        return items;
    }

    static getNames<T>(e: T): string[] {
        return Object.keys(e).filter(key => isNaN(+key));
    }

    public static enumToArray<T>(enumName: string, enumeration: T): IKeyValuePair<T>[] {
        if (this.enumCache[enumName]) {

            return this.enumCache[enumName];
        }

        const list: IKeyValuePair<T>[] = [];

        for (var n in enumeration) {
            if (typeof enumeration[n] === 'number') {
                list.push({
                    name: n,
                    value: enumeration[n] as any
                });
            }
        }

        list.sort((one, two) => (one.name > two.name ? 1 : -1))

        this.enumCache[enumName] = list;

        return list;
    }
}
